<template>
    <div class="dt-panelmenu clearfix">
        <div class="dataTables_length">
            <label>
                Показывать по
                <select name="clients_list_length" v-model="currentPerPage" class="form-control input-sm" @change="go">
                    <option v-for="(count, index) in counts" v-bind:key="'per-page-count-' + index">
                        {{count}}
                    </option>
                </select>
                записей
            </label>
        </div>
    </div>
</template>

<script>
    import Helper from "../../classes/Helper";

    export default {
        props: {
            perPage: Number,
            counts: {
                type: Array,
                default: () => [10, 25, 50, 100],
            },
            queryName: {
                type: String,
                default: 'per-page',
            },
        },
        data() {
            return {
                currentPerPage: this.perPage,
            };
        },
        watch: {
            perPage: function(value) {
                this.currentPerPage = value;
            },
        },
        methods: {
            getRoute() {
                const route = {
                    name: this.$route.name,
                    params: this.$route.params,
                    query: this.$route.query,
                };

                return Helper.copyObject(route);
            },
            go() {
                const to = this.getRoute();
                to.query[this.queryName] = this.currentPerPage;
                to.query.page = undefined;

                this.$router.push(to);
            },
        },
    }
</script>
